import React from 'react';
import { Helmet } from 'react-helmet';
import mantisWhiteLogo from '../Assets/img/mantisWhiteLogo2.png';
import PublicFooter from './PublicFooter';
import './styles/dataTreatment.scss';
import './styles/publicPages.scss';

const DataTreatmentPolicies = () => {
  return (
    <>
      <Helmet>
        <title>Políticas de Tratamiento de Datos - Mantis</title>
        <meta
          name="description"
          content="Políticas de tratamiento de datos personales de Mantis"
        />
      </Helmet>

      <div className="data-treatment-page">
        {/* Header */}
        <header className="page-header">
          <div className="container">
            <div className="logo-container">
              <img src={mantisWhiteLogo} alt="Mantis Logo" className="logo" />
            </div>
            <h1 className="doc-title">
              POLÍTICA DE PRIVACIDAD Y DE PROTECCIÓN DE DATOS PERSONALES DE MANTIS APP S.A.S.
            </h1>
          </div>
        </header>

        {/* Main Content */}
        <main className="page-content">
          <div className="container">
            <div className="content-wrapper">
              {/* <p className="subtitle">
                Última actualización: 26 de diciembre de 2023
              </p> */}

              <section className="policy-section">
                <h2 className="subtitle">Información General</h2>
                <p>
                  La sociedad MANTIS APP S.A.S., domiciliada en Bogotá D.C., Colombia e identificada 
                  con NIT 901712099 - 2 (en adelante, la "Sociedad"), dando cumplimiento a las normas 
                  contenidas en la Ley Estatutaria 1581 de 2012, el Decreto 1074 de 2015 y las demás 
                  normas concordantes, por las cuales se dictan disposiciones generales para la protección 
                  de datos personales, en su calidad de Responsable del Tratamiento de Datos Personales, 
                  se permite dar a conocer la presente Política de Privacidad y de Protección de Datos 
                  Personales (en adelante la "Política") para regular la recolección, almacenamiento, 
                  tratamiento, administración, transferencia, transmisión, protección y supresión de 
                  aquella información que se reciba de los titulares de datos personales o de terceros 
                  a través de los diferentes canales de recolección de datos que ha dispuesto en el 
                  desarrollo de sus actividades.
                </p>
              </section>

              <section className="policy-section">
                <h2 className="subtitle">III. Responsable del Tratamiento</h2>
                <p>
                  La persona jurídica responsable del tratamiento de datos personales y por tanto 
                  de la base de datos en la cual se encuentren ubicados los mismos, es MANTIS APP S.A.S., 
                  sociedad legalmente constituida, identificada con NIT: 901712099 - 2, con domicilio 
                  principal en la ciudad de Bogotá D.C, Colombia.
                </p>
                <p>
                  <strong>Dirección:</strong> Cra16a #137-29<br/>
                  <strong>Teléfono:</strong> 3154308744<br/>
                  <strong>Correo electrónico:</strong> jairo@mantisapp.co
                </p>
              </section>

              <section className="policy-section">
                <h2 className="subtitle">V. Finalidades del Tratamiento de los Datos Personales</h2>
                <p>
                  La Sociedad realizará el Tratamiento de los Datos Personales con los siguientes 
                  fines específicos:
                </p>
                <ol>
                  <li>Realizar tareas básicas de gestión administrativa.</li>
                  <li>Para los fines propios de los contratos que se hayan celebrado o a celebrar entre Mantis y sus usuarios y clientes, al igual que frente a los servicios que ofrece y presta Mantis a través de su página y/o sus aplicaciones y aquellas actividades derivadas de su objeto social.</li>
                  <li>Consultar la información del titular de los datos -y de su representante legal cuando corresponda- en listas restrictivas para prevenir lavado de activos, financiación del terrorismo, entre otras finalidades de prevención de riesgos.</li>
                  <li>Desarrollar los procesos que se requieran para la adecuada prestación de los productos y/o servicios contratados por los usuarios y/o clientes de Mantis.</li>
                  <li>Adelantar los trámites y servicios que sean solicitados a Mantis.</li>
                  <li>Actualizar Bases de Datos, incluyendo los casos en que se requiera transmitir o transferir a un tercero, la información para la validación, depuración, enriquecimiento y homogenización de datos, previo cumplimiento de las exigencias legales.</li>
                  <li>Proveer servicios y productos requeridos y dar cumplimiento a las demás obligaciones contraídas con el Titular.</li>
                  <li>Evaluar la calidad de los servicios de la Sociedad.</li>
                  <li>Desarrollar actividades de comunicación y posicionamiento de marca.</li>
                  <li>Informar sobre nuevos servicios que estén relacionados con los servicios contratados o adquiridos.</li>
                  <li>Transferir o transmitir la información plasmada en las comunicaciones recibidas por el titular por parte de Empresas aliadas.</li>
                  <li>Analizar y estudiar la información plasmada en las comunicaciones recibidas por el titular por parte de Empresas aliadas.</li>
                  <li>Adelantar las actividades necesarias para gestionar las solicitudes, quejas y reclamos presentadas por los clientes, usuarios y/o terceros, y direccionarlas a las áreas responsables de emitir las respuestas correspondientes.</li>
                  <li>Realizar la transferencia de información a terceros aliados con fines comerciales y en el marco de las demás finalidades contenidas en el presente documento.</li>
                  <li>Responder requerimientos legales de entidades administrativas y judiciales.</li>
                  <li>Soportar procesos de auditoría externa o interna.</li>
                  <li>El control y prevención de fraudes, lavado de activos y la financiación del terrorismo.</li>
                  <li>El desarrollo de actividades de investigación y de análisis estadístico.</li>
                  <li>Realizar estudios estadísticos.</li>
                  <li>Transferir y transmitir información para brindar mejores productos a los Titulares por parte de terceros.</li>
                  <li>Consultar y acceder a la información del Titular (privados, semiprivados, sensibles o reservados) en distintas bases de datos o Entidades Públicas o Privadas, ya sean en Colombia, en el Extranjero o Internacional.</li>
                  <li>Consultar la información del Titular en Centrales de Información Financiera, así como reportar información a estas bases de datos, cuando exista mérito para hacerlo con el lleno de requisitos legales para tal fin.</li>
                  <li>En general, para realizar directamente el Tratamiento, según este término se define en la Ley 1581 de 2012 a través de un encargado del tratamiento, ubicado en Colombia o en cualquier otro país a quien se le suministrarán los datos del Titular a través de transmisiones internacionales o nacionales, según el caso.</li>
                </ol>
              </section>

              <section className="policy-section">
                <h2 className="subtitle">VI. Derechos de los Titulares de los Datos Personales</h2>
                <p>
                  Los derechos que le asisten a los Titulares de los Datos Personales, son:
                </p>
                <ol>
                  <li>Conocer, actualizar y rectificar mis datos personales frente a los Responsables del Tratamiento o Encargados del Tratamiento. Este derecho se podrá ejercer, entre otros frente a datos parciales, inexactos, incompletos, fraccionados, que induzcan a error, o aquellos cuyo Tratamiento esté expresamente prohibido o no haya sido autorizado;</li>
                  <li>Solicitar prueba de la autorización otorgada al Responsable del Tratamiento salvo cuando expresamente se exceptúe como requisito para el Tratamiento, de conformidad con lo previsto en el artículo 10 de la presente ley;</li>
                  <li>Ser informado por el Responsable del Tratamiento o el Encargado del Tratamiento, previa solicitud, respecto del uso que le ha dado a mis datos personales;</li>
                  <li>Presentar ante la Superintendencia de Industria y Comercio quejas por infracciones a lo dispuesto en la presente ley y las demás normas que la modifiquen, adicionen o complementen;</li>
                  <li>Revocar la autorización y/o solicitar la supresión del dato cuando en el Tratamiento no se respeten los principios, derechos y garantías constitucionales y legales. La revocatoria y/o supresión procederá cuando la Superintendencia de Industria y Comercio haya determinado que en el Tratamiento el Responsable o Encargado han incurrido en conductas contrarias a esta ley y a la Constitución;</li>
                  <li>Acceder en forma gratuita a sus datos personales que hayan sido objeto de Tratamiento.</li>
                </ol>
                <p>
                  A su vez el Titular se compromete a brindar información cierta, veraz, exacta, autentica 
                  y vigente y se hace responsable por el contenido de la misma y de los perjuicios que cause 
                  a la Sociedad, o a terceras personas.
                </p>
              </section>

              <section className="policy-section">
                <h2 className="subtitle">XII. Procedimiento para que los Titulares de los Datos Personales puedan ejercer sus derechos</h2>
                <p>
                  El Titular de los datos podrá conocer, actualizar, rectificar y suprimir la información 
                  suministrada e igualmente podrá ejercer su derecho a revocar la autorización suministrada 
                  para su tratamiento enviando la respectiva solicitud al correo electrónico jairo@mantisapp.co, 
                  o a la línea telefónica 3154308744. Para tal efecto, el Titular deberá como mínimo indicar: 
                  nombres y apellidos, tipo de documento y número, teléfono, correo electrónico, descripción 
                  del asunto y los cambios específicos que quiere hacer, esto asegurará que procesemos su 
                  petición correctamente.
                </p>
                <p>
                  La consulta será atendida en un término máximo de diez (10) días hábiles contados a partir 
                  de la fecha de recibo de esta. Cuando no fuere posible atender la consulta dentro de dicho 
                  término, se informará al interesado, expresando los motivos de la demora y señalando la fecha 
                  en que se atenderá su consulta, la cual en ningún caso superará los cinco (5) días hábiles 
                  siguientes al vencimiento del primer término.
                </p>
              </section>

              <section className="policy-section">
                <h2 className="subtitle">IX. Medidas de seguridad para la Protección de los Datos Personales</h2>
                <p>
                  La Sociedad adoptará las técnicas de seguridad que sean necesarias para otorgar 
                  seguridad a los registros evitando su adulteración, pérdida, consulta, uso o acceso 
                  no autorizado o fraudulento. Dichas medidas responderán a los requerimientos mínimos 
                  hechos por la legislación vigente y periódicamente se evaluará su efectividad. 
                  Sin embargo, la Sociedad no responderá en caso de presentarse una violación a sus 
                  sistemas de seguridad cuando medie fuerza mayor o caso fortuito.
                </p>
                <p>
                  La Sociedad no asume responsabilidad alguna por los daños y perjuicios de toda 
                  naturaleza que puedan derivarse de la presencia de virus o de la presencia de otros 
                  elementos lesivos en los servicios prestados por terceros que puedan producir 
                  alteraciones en el sistema informático, documentos electrónicos o archivos del usuario.
                </p>
              </section>

              <section className="policy-section">
                <h2 className="subtitle">IV. Tratamiento de los Datos Personales</h2>
                <p>
                  La Sociedad, en su calidad de Responsable del Tratamiento debidamente autorizado, 
                  y todo aquel Encargado que designe, podrá realizar el Tratamiento de los Datos 
                  Personales suministrados, lo que incluye la recolección, almacenamiento, tratamiento, 
                  uso, actualización, circulación, administración, cesión, transferencia, transmisión, 
                  protección y supresión de los mismos.
                </p>
                <p>
                  Así mismo, se resalta que la Sociedad podrá, entre otras:
                </p>
                <ol>
                  <li>Designar a uno o varios Encargados del Tratamiento de los Datos Personales;</li>
                  <li>Transferir y/o transmitir los Datos Personales sujetos a Tratamiento a las compañías que hagan parte de su grupo empresarial, esto es, a compañías matrices, filiales o subsidiarias, así como a cualquier otro tercero, dentro o fuera del territorio nacional, bien sean personas jurídicas o naturales, nacionales o extranjeras, aun cuando en el país de ubicación del receptor no se cuenten con normas que establezcan un estándar de protección de datos similares a los vigentes en el territorio nacional;</li>
                  <li>Transferir y/o transmitir los Datos Personales sujetos a Tratamiento a terceros aliados que puedan brindar mejores servicios al Titular, de diferente clase, como créditos, servicios de salud, entre otros;</li>
                  <li>Proporcionar dichos Datos Personales a agentes, subcontratistas y demás terceros para la consecución de los fines relacionados en el acápite siguiente, y</li>
                  <li>Revelar la información cuando así lo requieran las autoridades debidamente facultadas mediante orden administrativa o judicial.</li>
                </ol>
              </section>

              <section className="policy-section">
                <h2 className="subtitle">X. Uso del Sitio Web</h2>
                <p>
                  La utilización del sitio web mantisapp.co (en adelante, "Sitio Web") implica 
                  la aceptación de esta política de privacidad por parte de los Titulares que 
                  hagan uso de ella. Por lo que aquellos Titulares que no estén de acuerdo con 
                  los términos acá incluidos deberán abstenerse de utilizar el Sitio Web. 
                  El Titular usuario del Sitio Web reconoce y acepta que la Sociedad podrá 
                  utilizar un sistema de seguimiento mediante la utilización de cookies.
                </p>
                <p>
                  Las cookies utilizadas por el Sitio Web son ficheros enviados a un navegador 
                  por medio de un servidor web para registrar las actividades del usuario en la 
                  página Web y permitirle una navegación más fluida y personalizada. En todo caso, 
                  el usuario tiene la posibilidad de configurar su navegador para impedir la entrada 
                  de éstas, bloquearlas o, en su caso, eliminarlas. Lo anterior será responsabilidad 
                  exclusiva del Titular.
                </p>
              </section>

              <section className="policy-section">
                <h2 className="subtitle">XI. Área responsable del tratamiento de Datos Personales</h2>
                <p>
                  El área de servicio al cliente será el área encargada de atención de las 
                  peticiones, consultas y reclamos ante la cual el Titular de la información 
                  podrá ejercer sus derechos y por tanto a conocer, actualizar, modificar, 
                  rectificar, corregir o suprimir la información suministrada en cualquier 
                  momento y para tal efecto deberá enviar un correo electrónico con su 
                  solicitud a jairo@mantisapp.co comunicarse al teléfono +57 3154308744.
                </p>
              </section>

              <section className="policy-section">
                <h2 className="subtitle">XVII. Vigencia de la Política</h2>
                <p>
                  La presente Política de Tratamiento de datos Personales rige a partir 
                  del 26 de diciembre de 2023.
                </p>
                <p>
                  Mantis App S.A.S. podrá modificar esta política de tratamiento de datos, 
                  sin previo aviso y en cualquier momento, por lo cual, el Titular de los 
                  datos deberá revisar la página web de manera constante, ya que dicho 
                  documento actualizado estará al alcance de los titulares siempre.
                </p>
                <p style={{ marginTop: '2rem', textAlign: 'center' }}>
                  <strong>Jairo Andrés Pitta</strong><br/>
                  <em>Representante Legal</em>
                </p>
              </section>
            </div>
          </div>
        </main>

        {/* Footer */}
        <PublicFooter />
      </div>
    </>
  );
};

export default DataTreatmentPolicies;
